import {ListView} from '@github-ui/list-view'
import {ListItem} from '@github-ui/list-view/ListItem'
import {ListItemDescription} from '@github-ui/list-view/ListItemDescription'
import {ListItemDescriptionItem} from '@github-ui/list-view/ListItemDescriptionItem'
import {ListItemMainContent} from '@github-ui/list-view/ListItemMainContent'
import {ListItemTitle} from '@github-ui/list-view/ListItemTitle'
import type {Icon} from '@primer/octicons-react'
import {Link} from '@primer/react'

import styles from './AIResourceResults.module.css'

export type AIResourceResult = {
  id: string
  /** An authorized canonical destination supplied by the composing application. */
  href: string
  name: string
  description?: string
  resourceType: string
  resourceTypeIcon?: Icon
  publisher?: {
    name: string
    /** An authorized canonical destination supplied by the composing application. */
    href: string
  }
  labels: readonly string[]
}

export type AIResourceResultsProps = {
  results: readonly AIResourceResult[]
}

export function AIResourceResults({results}: AIResourceResultsProps) {
  if (results.length === 0) return null

  return (
    <ListView itemsListClassName={styles.List} title="AI resources" totalCount={results.length}>
      {results.map(result => (
        <AIResourceResultRow key={result.id} result={result} />
      ))}
    </ListView>
  )
}

export function AIResourceResultRow({result}: {result: AIResourceResult}) {
  const ResourceTypeIcon = result.resourceTypeIcon

  return (
    <ListItem
      className={styles.Row}
      title={
        <ListItemTitle href={result.href} value={result.name} linkProps={{as: Link, className: 'Link--inTextBlock'}} />
      }
    >
      <ListItemMainContent>
        <div className={styles.Content}>
          {result.description && (
            <ListItemDescription>
              <ListItemDescriptionItem>{result.description}</ListItemDescriptionItem>
            </ListItemDescription>
          )}

          <ListItemDescription className={styles.Footer}>
            <span className={styles.ResourceType}>
              {ResourceTypeIcon && <ResourceTypeIcon aria-hidden="true" data-testid="resource-type-icon" />}
              <span>{result.resourceType}</span>
            </span>
            {result.publisher && (
              <span className={styles.Publisher}>
                By{' '}
                <Link href={result.publisher.href} inline>
                  {result.publisher.name}
                </Link>
              </span>
            )}
          </ListItemDescription>
        </div>
      </ListItemMainContent>
    </ListItem>
  )
}
